import { useEffect, useRef, useState } from "react";
import { Calculator, FileSearch } from "lucide-react";
import { HERO_VIDEOS, HERO_POSTER, scrollToId } from "../data/siteData";
import { HERO_COPY } from "../data/copy";
export default function HeroSection() {
  const [active, setActive] = useState(0);
  const refs = useRef([]);
  const activeRef = useRef(0);
  const switching = useRef(false);
  useEffect(() => {
    const first = refs.current[0];
    if (first) first.play().catch(() => {});
    // A queued clip is decoded before switching so we do not display a black frame.
    const tick = () => {
      const current = refs.current[activeRef.current];
      if (!current || switching.current || !Number.isFinite(current.duration)) return;
      if (current.duration - current.currentTime < 0.35) {
        switching.current = true;
        const next = (activeRef.current + 1) % HERO_VIDEOS.length;
        const incoming = refs.current[next];
        if (!incoming || incoming.readyState < 3) {
          current.currentTime = 0;
          switching.current = false;
          return;
        }
        incoming.currentTime = 0;
        incoming.play().then(() => {
          requestAnimationFrame(() => {
            const previous = activeRef.current;
            activeRef.current = next;
            setActive(next);
            requestAnimationFrame(() => { refs.current[previous]?.pause(); switching.current = false; });
          });
        }).catch(() => { current.currentTime = 0; switching.current = false; });
      }
    };
    const timer = window.setInterval(tick, 70);
    return () => window.clearInterval(timer);
  }, []);
  return <section className="relative flex items-center overflow-hidden bg-[#0B1F44]" style={{minHeight:"calc(100svh - 72px)"}} data-testid="hero-section">
    <div className="absolute inset-0">
      {HERO_VIDEOS.map((src,i) => <video key={src} ref={node => {refs.current[i]=node;}} src={src} muted playsInline preload="auto" poster={HERO_POSTER} autoPlay={i===0} loop={false} onEnded={() => { const v=refs.current[i]; if(i===activeRef.current && v) {v.currentTime=0;v.play().catch(()=>{});switching.current=false;} }} className="absolute inset-0 h-full w-full object-cover" style={{opacity: i===active?1:0,zIndex:i===active?2:1,transition:"none",display:"block"}} />)}
      <div className="absolute inset-0 bg-gradient-to-r from-[#07172a]/65 via-[#07172a]/10 to-transparent pointer-events-none" style={{zIndex:3}}/>
    </div>
    <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 w-full">
      <div className="max-w-3xl">
        <h1 className="hero-text-shadow text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white leading-[1.08]">
          <span className="block">{HERO_COPY.heading}</span>
          <span className="block text-[#9FD0FF]">{HERO_COPY.accent}</span>
        </h1>
        <p className="hero-text-shadow mt-6 text-base sm:text-lg text-white/90 leading-relaxed max-w-2xl">{HERO_COPY.subtitle}</p>
        <div className="mt-9 flex flex-col sm:flex-row gap-4"><button onClick={()=>scrollToId("get-quote")} className="inline-flex items-center justify-center gap-2 rounded-full bg-[#0066FF] hover:bg-[#0052CC] text-white font-semibold px-8 py-4 text-base"><FileSearch size={19}/>{HERO_COPY.primaryButton}</button><button onClick={()=>scrollToId("rate-calculator")} className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-white/50 hover:border-white text-white font-semibold px-8 py-4 text-base"><Calculator size={18}/>{HERO_COPY.secondaryButton}</button></div>
      </div>
    </div>
  </section>;
}
